import {Component, Input} from '@angular/core';
import { CommonModule } from '@angular/common';
import {Product} from "../../product-details/interface/product";
import {MatDialog} from "@angular/material/dialog";
import {ProductPreOrderDialogComponent} from "../product-pre-order-dialog/product-pre-order-dialog.component";

@Component({
	selector: 'fb-product-cart-buttons',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './product-cart-buttons.component.html',
	styleUrls: ['./product-cart-buttons.component.scss']
})
export class ProductCartButtonsComponent {

	@Input()
	public product: Product = {} as Product;

	constructor(
		private _dialog: MatDialog
	) {
	}

	openPreOrderDialog() {
		const dialogRef = this._dialog.open(
			ProductPreOrderDialogComponent, {
				id: 'product-pre-order-dialog',
				data: this.product,
				width: '100vw',
				maxWidth: '800px',
				maxHeight: '100vh',
				position: {
					top: '0',
					right: '0'
				}
			});
	}
}
